{
    "save": "Guardar",
    "edit": "Editar",
    "update": "Actualizar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "move_to": "Mover a",
    "close": "Cerrar",
    "detail": "Detalle",
    "copy": "Copiar",
    "copied_text": "Texto copiado",
    "confirm_delete_record_NAME": "¿Seguro que quieres eliminar el registro \":name\"?",
    "confirm_delete_FIELD_NAME": "¿Seguro que quieres eliminar :field \":name\"?",
    "record_RECORD_doesnt_exist_in_the_TABLE_table": "El registro \":record\" no existe en la tabla :table",
    "min_MIN_characters_on_search": "La búsqueda debe tener al menos :min caracteres",
    "add_FIELD": "Añadir :field",
    "see_FIELD": "Ver :field",
    "edit_FIELD_NAME": "Editar :field \":name\"",
    "the_page": "la página",
    "cannot_save_an_error": "No puedes guardar un error",
    "incorrect_blade_format": "Formato blade incorrecto",
    "to_empty": "Vaciar",
    "launch": "Lanzar",
    "correct": "Correcto",
    "ok": "De acuerdo",
    "reload_page": "Recargar página",
    "unforeseen_error": "Error imprevisto",
    "loading": "Cargando",
    "loading_dots": "Cargando...",
    "search": "Buscar",
    "searching_dots": "Buscando...",
    "no_results": "Sin resultados",
    "filter": "Filtrar",
    "date": "Fecha",
    "download_completed": "Descarga completada",
    "fetch_error_message": "Hubo un problema con la petición Fetch^:",
    "some_class_does_not_meet_the_INTERFACE_interface_contract": "Alguna Clase no cumple con el contrato de la interfaz :interface",
    "it_has_been_called_a_JS_component_that_does_not_match_the_current_page": "Se ha llamado un componente JS que no coincide con la pagina actual",
    "need_NUMBER_characters": "Necesarios :number caracteres",
    "a_loader_was_expected_on_the_page": "Se esperaba un loader en la página",
    "check_if_the_loader_was_in_a_div": "Comprueba si el loader estaba en un div. En ese caso se requiere el id del div.",
    "you_do_not_have_permissions_to_edit": "No tienes permisos para editar",

    "select_search_placeholder": "Buscar...",
    "select_search_text": "Sin datos",
    "select_searching_text": "Buscando...",
    "select_results_text": "{count} resultados disponibles",
    "select_deselect_text": "Limpiar",
    "select_remove_text": "Eliminar",
    "select_placeholder_text": "Selecciona un valor",
    "select_maxValues_message": "{number} seleccionados",
    "select_addable_text": "Pulsa \"Enter\" para añadir {value}",
    "select_debounce_MIN_characters": "La búsqueda debe tener al menos :min caracteres",
    "select_debounce_empty_results": "No se han encontrado resultados"
}
